export var isoStringToTime = function isoStringToTime() {
  var dateTimeString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var match = dateTimeString.match(/T(\d{2}):(\d{2})/);
  return match ? {
    hours: parseInt(match[1], 10),
    minutes: parseInt(match[2], 10)
  } : undefined;
};
export var dateTimeToTime = function dateTimeToTime(dateTime) {
  return {
    hours: dateTime.getHours(),
    minutes: dateTime.getMinutes()
  };
};
export var isTimeSame = function isTimeSame(timeA, timeB) {
  return timeA.hours === timeB.hours && timeA.minutes === timeB.minutes;
};
export var isTimeAfter = function isTimeAfter(timeA, timeB) {
  return timeA.hours > timeB.hours || timeA.hours === timeB.hours && timeA.minutes > timeB.minutes;
};
export var isTimeSameOrAfter = function isTimeSameOrAfter(timeA, timeB) {
  return isTimeSame(timeA, timeB) || isTimeAfter(timeA, timeB);
};
export var isTimeBefore = function isTimeBefore(timeA, timeB) {
  return timeA.hours < timeB.hours || timeA.hours === timeB.hours && timeA.minutes < timeB.minutes;
};
export var isTimeSameOrBefore = function isTimeSameOrBefore(timeA, timeB) {
  return isTimeSame(timeA, timeB) || isTimeBefore(timeA, timeB);
};
export var isTimeInRange = function isTimeInRange(dateTime, startTime, endTime) {
  var time = dateTimeToTime(dateTime);
  return isTimeSameOrAfter(time, startTime) && isTimeSameOrBefore(time, endTime);
};